export default el => {
	const inputs = el.querySelectorAll('input[type="checkbox"]');

	inputs.forEach(input => {
		input.addEventListener('change', () => {
			if (input.checked) {
				inputs.forEach(other => {
					if (other !== input) {
						other.checked = false;
					}
				})
			}	
		})
	})
};